export default () => ({
  exclamationIcon: {
    fill: '#FF0000',
  },
});
